export default "__VITE_ASSET__DI1QTrc4__"